<template>
  <v-dialog
    :value="show"
    content-class="fileuploader-dialog"
  >
    <UploadStatus
      v-for="status in statuses"
      :key="status.filename"
      :progress="status.progress"
      :filename="status.filename"
    />
  </v-dialog>
</template>

<script>
import UploadStatus from './UploadStatus';

export default {
  components: { UploadStatus },
  props: {
    statuses: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
::v-deep .fileuploader-dialog {
  min-width: 300px;
  max-width: 800px;
  width: auto;
  max-height: 80vh;
  box-shadow: none;
  padding: 4px;
}
</style>
